// The friends panel's words (owner 2026-10-01 redesign), pure.
import { serverNow } from '../state/serverClock.mjs';
export function lastSeenText(iso, nowMs = serverNow(), online = false) {
  if (online) return 'Teraz gra';
  const t = Date.parse(iso ?? '');
  if (Number.isNaN(t)) return 'Dawno';
  const mins = Math.floor((nowMs - t) / 60000);
  if (mins < 1) return 'Przed chwilą';
  if (mins < 60) return `${mins} min temu`;
  const h = Math.floor(mins / 60);
  if (h < 24) return `${h} godz. temu`;
  const d = Math.floor(h / 24);
  if (d === 1) return 'Wczoraj';
  if (d < 14) return `${d} dni temu`;
  if (d < 31) { const w = Math.floor(d / 7); return `${w} ${w < 5 ? 'tygodnie' : 'tygodni'} temu`; }
  return 'Ponad miesiąc temu';
}

// A friend's canister waiting to be seen (farm.new_gifts), shown at the top of the friends panel
// with a one-tap thank-you (owner 2026-10-01: the red dot on Znajomi was otherwise unexplained).
export const giftRowText = (g) => `Kanister paliwa od ${g.name}`;

// The list's order (owner 2026-10-20): playing now first, then the most recently played;
// never-seen at the end; ties by name. A sorted copy — the panel keeps its own array.
export function sortFriends(list) {
  const seen = (f) => { const t = Date.parse(f.last_seen_at ?? ''); return Number.isNaN(t) ? -Infinity : t; };
  return [...list].sort((a, b) => (!!b.online - !!a.online) || (seen(b) - seen(a))
    || String(a.name).localeCompare(String(b.name), 'pl'));
}
